import {
    SEND_EMAIL_COPY,
    CLEAN_SEND_EMAIL
  } from '../actions';
  
  const iniState = {
    sendEmailData: null,
    sendEmailFailed: false,
    sendEmailLoading: false,
    sendEmailSucceeded: false
  };
  
  export default (state = iniState, action) => {
    switch (action.type) {
        case CLEAN_SEND_EMAIL:
        return {
            sendEmailData: null,
            sendEmailLoading: false,
            sendEmailFailed: false,
            sendEmailSucceeded: false
        };
      case `${SEND_EMAIL_COPY}_PENDING`:
        return {
          ...state,
          sendEmailData: null,
          sendEmailLoading: true,
          sendEmailFailed: false,
          sendEmailSucceeded: false
        };
      case `${SEND_EMAIL_COPY}_REJECTED`:
        return {
          ...state,
          sendEmailData: action.payload ? action.payload.data : null,
          sendEmailLoading: false,
          sendEmailFailed: true,
          sendEmailSucceeded: false
        };
      case `${SEND_EMAIL_COPY}_FULFILLED`:
        return {
          ...state,
          sendEmailData: action.payload ? action.payload.data : null,
          sendEmailLoading: false,
          sendEmailFailed: false,
          sendEmailSucceeded: true
        };
      default:
        return state
  
    }
  };